import { DateTime } from 'luxon';
import { FormattedDateTimeRange } from 'react-intl';
import { isTruthy } from '@_/utils';

interface FormattedDateRangeProps extends Pick<Intl.DateTimeFormatOptions, 'dateStyle'> {
  values: DateTime[] | string[];
}

export function FormattedDateRange({ values, ...otherProps }: FormattedDateRangeProps) {
  const dates = values
    .map(value => (typeof value === 'string' ? DateTime.fromISO(value) : value))
    .filter(isTruthy);

  if (!dates.length) {
    return;
  }

  const fromDate = dates[0];
  const toDate = dates.length === 2 ? dates[1] : dates[0];

  return (
    <FormattedDateTimeRange from={fromDate.toJSDate()} to={toDate.toJSDate()} {...otherProps} />
  );
}
